import StorageLocal from "@homer.core/storage.local";
import application from "@homer.core/application";
import { name } from "../package.json";

const storageLocal = new StorageLocal(name, { version: application.version, lifetime: 600 });

export default {
    get(client) {
        const token = JSON.parse(storageLocal.get() || '{"value":null}');

        if (token.value) {
            return Promise.resolve(token.value);
        }

        return client.post("/token/retrieve").then((response) => {
            token.value = response.token || null;

            storageLocal.set(JSON.stringify(token));

            return response.token;
        });
    },
    refresh(client) {
        return client.post("/token/retrieve").then((response) => {
            const token = {
                value: response.token || null,
            };

            storageLocal.set(JSON.stringify(token));

            return response.token;
        });
    },
};
